module.exports = __webpack_public_path__ + "static/media/qual-logo.8f2446dd.svg";